import { useQuery } from 'react-query'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getSalesFunnelList } from '../api'

export const useGetSalesFunnelListForFilters = () => {
  const dispatch = useAppDispatch()
  const { data, ...rest } = useQuery(
    ['filters', 'shared', 'salesFunnels'],
    async () => {
      await dispatch(getSalesFunnelList(false))
    },
  )
  return rest
}
